"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useGetMySprints = void 0;
var BP = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/sprints/get-my-sprints"));
var SprintsForUserPSB = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/pubsub/sprints-for-user-spec"));
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var react_1 = __importDefault(require("react"));
/**
 * Will automatically refresh when sprints change
 */
function useGetMySprints(
/** @deprecated */
params) {
    var client = (0, omni_continuity_1.useClient)();
    var tenant = (0, omni_continuity_1.useTenant)();
    var self = (0, omni_continuity_1.useSelf)();
    var query = client.useQuery(BP, null);
    var onPush = react_1["default"].useCallback(function () { return query.refresh({ subtle: true }); }, []);
    client.useSubscribeToTopic(SprintsForUserPSB, "[".concat(tenant, "]sprints-for-user/for:").concat(self.userId), onPush);
    return query;
}
exports.useGetMySprints = useGetMySprints;
